<script setup lang="ts">
import type { CsvColumn, CsvRow } from '@/utils/csv-export';
import { downloadCsv } from '@/utils/csv-export';

const props = withDefaults(defineProps<{
  columns: CsvColumn[];
  rows: CsvRow[];
  filename: string;
  label?: string;
  compact?: boolean;
}>(), {
  label: '导出数据',
  compact: false,
});

function runExport(): void {
  if (!props.rows.length) return;
  downloadCsv(props.filename, props.columns, props.rows);
}
</script>

<template>
  <button
    class="export-data-button"
    :class="compact ? 'inline-button' : 'button button-secondary'"
    type="button"
    :disabled="!rows.length"
    :title="rows.length ? `导出当前结果，共 ${rows.length} 条` : '暂无可导出数据'"
    data-export-data
    @click="runExport"
  >
    {{ label }}<span v-if="rows.length">（{{ rows.length }}）</span>
  </button>
</template>

